'use strict';


module.exports = {
    debug: window.gSTB.Debug,
    reboot: function () {
        window.gSTB.ExecAction('reboot');
    },
    reload: function ( url ) {
        var portalWinId = 1,
            currentWinId = window.stbWebWindow.windowId(),
            windowList = JSON.parse(window.stbWindowMgr.windowList()),
            index;

        if ( DEVELOP ) {
            debug('mag')('reload called');
        }

        url = url || 'file:///home/web/system/pages/loader/index.html';

        document.body.style.display = 'none';
        /* eslint new-cap: 0 */
        top.gSTB.Stop();

        if ( top.stbPlayerManager && typeof top.stbPlayerManager.reset === 'function' ) {
            // TODO: remove this check, when task http://192.168.1.220:3000/issues/22782 will be closed
            top.stbPlayerManager.reset();
        }

        for ( index = 0; index < windowList.result.length; index++ ) {
            if ( windowList.result[index] !== portalWinId && windowList.result[index] !== currentWinId ) {
                window.stbWindowMgr.closeWindow(windowList.result[index]);
            }
        }

        window.stbStorage.clear();
        window.stbWindowMgr.windowLoad(portalWinId, url);
        // window.stbWindowMgr.closeWindow(0);
    },
    runNativeApp: function ( config ) {

        var app = {
            id: config.applicationId
        };

        if ( DEVELOP ) {
            debug('system')('native app: ' + JSON.stringify(app));
        }

        if ( typeof window.stbAppManager !== 'undefined' ) {
            if ( typeof window.stbAppManager.isInstalled === 'function' ) {
                if ( window.stbAppManager.isInstalled(config.applicationId) ) {
                    window.stbAppManager.start(app);

                    if ( DEVELOP ) {
                        debug('system')('native app: ' + JSON.stringify(app));
                    }

                } else {
                    window.stbAppManager.start({
                        id: 'market://details?id=' + config.applicationId
                    });

                    if ( DEVELOP ) {
                        debug('system')('native app: ' + JSON.stringify({
                            id: 'market://details?id=' + config.applicationId
                        }));
                    }
                }
            } else if ( typeof window.stbAppManager.start === 'function' ) {
                window.stbAppManager.start({
                    id: config.applicationId
                });

                if ( DEVELOP ) {
                    debug('system')('native app: ' + JSON.stringify(app));
                }
            }
        }
    }
};
